import React, { FC } from 'react';
import classNames from 'classnames';
import View from '../view';
import Text from '../text';
import Loading from '../loading';
import Button from '../button';

interface ILoadMoreProps {
  /**
   * css class
   */
  className?: string;
  /**
   * noMore 状态显示文案 css class
   */
  noMoreTextClassName?: string;
  /**
   * more 状态按钮 css class
   */
  moreBtnClassName?: string;
  /**
   * 状态
   * @default more
   */
  status?: 'more' | 'loading' | 'noMore';
  /**
   * loading 状态显示文案
   * @default 加载中
   */
  loadingText?: string;
  /**
   * more 状态显示文案
   * @default 查看更多
   */
  moreText?: string;
  /**
   * noMore 状态显示文案
   * @default 没有更多
   */
  noMoreText?: string;
  /**
   * more 状态点击回调函数
   */
  onClick?: () => void;
}

const LoadMore: FC<ILoadMoreProps> = ({
  className = '',
  noMoreTextClassName = '',
  moreBtnClassName,
  status = 'more',
  loadingText = '加载中',
  moreText = '查看更多',
  noMoreText = '没有更多',
  onClick,
}) => {
  let component: JSX.Element | null = null;
  if (status === 'loading') {
    component = (
      <Loading horizontal size={32}>
        {loadingText}
      </Loading>
    );
  } else if (status === 'more') {
    component = (
      <View className="ink-load-more__cnt">
        <Button size="mini" full onClick={onClick} className={moreBtnClassName}>
          {moreText}
        </Button>
      </View>
    );
  } else {
    component = <Text className={classNames('ink-load-more__tip', noMoreTextClassName)}>{noMoreText}</Text>;
  }

  return <View className={classNames('ink-load-more', className)}>{component}</View>;
};

export default LoadMore;
